import { combineReducers } from 'redux';
import { notificationsReducer } from '../notifications';
import { queueReducer } from '../queue';
import { settingsReducer } from '../settings';
import { toastsReducer } from '../toasts';

export const rootReducer = combineReducers({
    notifications: notificationsReducer,
    toasts: toastsReducer,
    queue: queueReducer,
    settings: settingsReducer,
    username: (state = '') => state,
});
